jQuery(document).on('ready', function () {
    if (jQuery('.location-picker').length) {
        jQuery('body').css('background', '#000');
        jQuery('footer').remove();
    }
    setTimeout(function() {
	    resizeLocationWrapper();
    }, 300);
});

jQuery(window).on('resize', function () {
    setTimeout(function() {
	    resizeLocationWrapper();
    }, 300);
});

var isResizing = false;
function resizeLocationWrapper() {
    if (jQuery('.location-picker').length && !isResizing) {
        isResizing = true;
        jQuery('.location-picker .location').each(function() {
            jQuery(this).children('.location-background, .location-background-rollover, .location-overlay, .location-link').css({
                'width': '',
                'height': ''
            });
            jQuery(this).css({
                'width': '',
                'height': ''
            });
        });
        jQuery('.location-picker .location').each(function() {
            var locationTextWidth = Math.round(jQuery(this).children('.location-text').width());
            var locationTextHeight = Math.round(jQuery(this).children('.location-text').height());
            jQuery(this).children('.location-background, .location-background-rollover, .location-overlay, .location-link').css({
                'width': locationTextWidth + 'px',
                'height': locationTextHeight + 'px'
            });
            jQuery(this).css({
                'width': locationTextWidth + 'px',
                'height': locationTextHeight + 'px'
            });
        });
        isResizing = false;
        setTimeout(function() {
            if( jQuery('.location-picker-info-box').length ) {
                var menuHeight = jQuery('.header').height();
                var spacing = 20;
                var locationPickerInfoBoxHeight = jQuery('.location-picker-info-box').height();
                var locationPickerHeight;
                if (window.matchMedia('(max-width: 992px)').matches) {
                    locationPickerHeight = 'calc(100vh - ' + menuHeight + 'px - ' + spacing + 'px - ' + locationPickerInfoBoxHeight + 'px)';
                } else {
                    locationPickerHeight = 'calc(100vh - ' + menuHeight + 'px - ' + spacing + 'px)';
                }
                jQuery('.location-picker').css('height', locationPickerHeight);
            }
            jQuery('.location-picker').css('opacity', 1);
        }, 600);
    }
}